var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAskAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 24.9982V17.9982C14 17.1545 14.6875 16.4982 15.5 16.4982H16.75C17.1562 16.4982 17.5 16.1545 17.5 15.7482V14.1857L20.375 16.217C20.625 16.4045 20.9375 16.4982 21.25 16.4982H24.5C25.3438 16.4982 26 17.1545 26 17.9982V24.9982C26 25.8107 25.3438 26.4982 24.5 26.4982H15.5C14.6875 26.4982 14 25.8107 14 24.9982ZM15.5 27.9982H24.5C26.1562 27.9982 27.5 26.6545 27.5 24.9982V22.9982H29.25C29.6562 22.9982 30 22.6545 30 22.2482C30 21.842 29.6562 21.4982 29.25 21.4982H27.5V17.9982C27.5 16.342 26.1562 14.9982 24.5 14.9982H21.25L17.1875 12.1232C16.9688 11.967 16.6562 11.967 16.4062 12.092C16.1562 12.217 16 12.467 16 12.7482V14.9982H15.5C13.8438 14.9982 12.5 16.342 12.5 17.9982V21.4982H10.75C10.3438 21.4982 10 21.842 10 22.2482C10 22.6545 10.3438 22.9982 10.75 22.9982H12.5V24.9982C12.5 26.6545 13.8438 27.9982 15.5 27.9982ZM18 24.9982H22C23.6562 24.9982 25 23.6545 25 21.9982C25 20.342 23.6562 18.9982 22 18.9982H18C16.3438 18.9982 15 20.342 15 21.9982C15 23.6545 16.3438 24.9982 18 24.9982ZM18 22.9982C17.4375 22.9982 17 22.5607 17 21.9982C17 21.4357 17.4375 20.9982 18 20.9982C18.5625 20.9982 19 21.4357 19 21.9982C19 22.5607 18.5625 22.9982 18 22.9982ZM21 21.9982C21 21.4357 21.4375 20.9982 22 20.9982C22.5625 20.9982 23 21.4357 23 21.9982C23 22.5607 22.5625 22.9982 22 22.9982C21.4375 22.9982 21 22.5607 21 21.9982Z",
    fill: "url(#paint0_linear_716_2605)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_716_2605",
    x1: 10,
    y1: 12.0001,
    x2: 30,
    y2: 28.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB083E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC03DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskAi);
export default __webpack_public_path__ + "static/media/ask_ai.acfb6131c41aae350a09224802d4199b.svg";
export { ForwardRef as ReactComponent };